import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <CommentsSection />
        <AboutSection />
        <ContactSection />
        <FaqSection />
        <MediaSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <TopicsSection />
        <CarouselSection />
        <IndexSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}